import { Button, Flex, FormControl, Grid, Input, Text } from "@chakra-ui/react"

import Card from "components/Card/Card"
import CardHeader from "components/Card/CardHeader"
import CardBody from "components/Card/CardBody"
import { useState } from "react"
import { LOGIN } from "services/auth"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { authCreator } from "state/index"

interface FormData {
    email: string
    password: string
}

const initialState = {
    email: '',
    password: ''
}

const Login = () => {
    const dispatch = useDispatch();
    const { login } = bindActionCreators(authCreator, dispatch)

    const [data, setData] = useState<FormData>(initialState);
    const [loginLoading, setLoginLoading] = useState<boolean>(false);
    const [loginError, setLoginError] = useState<boolean>(false);

    const onLogin = async () => {
        setLoginError(false);
        setLoginLoading(true);
        try {
            const response = await LOGIN(data);
            login(response.token)
            window.localStorage.setItem('token', response.token);
        } catch (err) {
            setLoginError(true);
        } finally { 
            setLoginLoading(false);
        }
    }

    return (
        <Flex w="full" minH="100vh" justifyContent="center" alignItems="center">
            <Card maxW="420px" minH="460px">
                <CardHeader minH="80px" justifyContent="center" alignItems="center">
                    Login
                </CardHeader>
                <CardBody mt="auto" mb="auto">
                    <Flex flexDirection="column" w="full">
                        <Grid
                            w="full"
                            templateColumns="repeat(1, 1fr)"
                            templateRows="repeat(2, 1fr)"
                            gap="16px"
                            mb="4"
                        >
                            <FormControl>
                                <Input
                                    value={data.email}
                                    onChange={({ target }) => setData({ ...data, email: target.value })}
                                    disabled={loginLoading}
                                    placeholder="E-mail"
                                    borderRadius="8px"
                                    fontSize="md"
                                />
                            </FormControl>
                            <FormControl>
                                <Input
                                    value={data.password}
                                    onChange={({ target }) => setData({ ...data, password: target.value })}
                                    disabled={loginLoading}
                                    placeholder="Senha"
                                    type="password"
                                    borderRadius="8px"
                                    fontSize="md"
                                />
                            </FormControl>
                        </Grid>
                        <Flex w="full" mb="2">
                            <Button
                                isLoading={loginLoading}
                                disabled={loginLoading}
                                w="full"
                                colorScheme="green"
                                onClick={onLogin}
                            >Entrar</Button>
                        </Flex>
                        {loginError && <Text color="red.400">Usuário ou senha inválidos. Tente novamente.</Text> }
                        {/* <Flex w="full">
                            <Text fontSize="14">Problemas com login</Text>
                        </Flex> */}
                    </Flex>
                </CardBody>
            </Card>
        </Flex>
    )
}

export default Login